export const getIframeAllow = (uiIntegration) => {
    const permissions = ["clipboard-write", "clipboard-read"];
    if (uiIntegration?.allowLocalNetworkAccess) {
        permissions.push("local-network-access");
    }
    if (uiIntegration?.allowMediaCapture) {
        permissions.push("display-capture", "camera", "microphone");
    }
    return permissions.map(permission => `${permission};`).join(" ");
};
